<template>
  <div class="layout-topbar" :class="{ 'sticky-topbar': true, 'mobile-topbar': isMobileView }">
    <!-- Global backdrop for panels -->
    <div 
      class="global-panel-backdrop" 
      :class="{ 'active': showNotifications || showMessages }" 
      @click="closeAllPanels"
    ></div>
    
    <!-- Desktop panel backdrop -->
    <div 
      class="desktop-panel-backdrop" 
      :class="{ 'active': !isMobileView && (showNotifications || showMessages) }" 
      @click="closeAllDesktopPanels"
    ></div>
    
    <!-- Desktop tasarım -->
    <div
      v-if="!isMobileView"
      class="layout-topbar-right"
      :class="{ 'layout-topbar-mobile-active': mobileTopbarActive }"
    >
      <div class="mobile-logo">
        <div class="pointer" @click="onMenuButtonClick">
          <div class="mobile-logo-container">
            <img loading="lazy" src="/img/logo.png" class="mobile-logo-img" alt="CrowdHRs Logo" />
            <div class="mobile-menu-icon" aria-label="Toggle menu">
              <i class="pi pi-bars"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="layout-topbar-actions-right"
        v-if="this.loggedIn != null && this.loggedIn"
      >
        <ul class="layout-topbar-items" >
          <!-- Redesigned Points display for user ID 2 -->
          <li v-if="showUserPoints" class="layout-topbar-item points-display">
            <div class="points-container">
              <div class="points-icon-wrapper">
                <i class="pi pi-star-fill"></i>
              </div>
              <span class="points-value">{{ userPoints }}</span>
              <span class="points-label hide-on-small">Points</span>
            </div>
          </li>
          <li class="layout-topbar-item notifications d-flex">
            <RouterLink
              to="/"
              class="layout-topbar-action rounded-circle d-flex align-items-center justify-content-center"
              v-ripple
            >
              <div
                class="w-100 h-100 d-flex align-items-center justify-content-center"
                style="color: white"
              >
                <svg
                  style="width: 23px; height: 23px; fill: white;"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path
                    d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
                  />
                </svg>
              </div>
            </RouterLink>
            <div class="notification-container">
              <a
                class="layout-topbar-action rounded-circle d-flex align-items-center justify-content-center"
                @click="toggleNotifications($event)"
                aria-label="Notifications"
                type="button"
                v-ripple
              >
                <div v-if="unreadCount > 0" class="badge-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    height="22"
                    width="22"
                    style="width: 22px; height: 22px; fill: white;"
                  >
                    <path
                      d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
                    />
                  </svg>
                  <span class="badge-counter">{{ unreadCount }}</span>
                </div>
                <div v-else>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    height="22"
                    width="22"
                    style="width: 22px; height: 22px; fill: white;"
                  >
                    <path
                      d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
                    />
                  </svg>
                </div>
              </a>
            </div>
            <a
              class="layout-topbar-action rounded-circle d-flex align-items-center justify-content-center messages-container"
              @click="toggleMessages($event)"
              aria-label="Messages"
              type="button"
              v-ripple
            >
              <div class="badge-container" v-if="unreadMessages > 0">
                <i class="fa-solid fa-envelope" style="font-size: 22px; color: white;"></i>
                <span class="badge-counter">{{ unreadMessages }}</span>
              </div>
              <div v-else>
                <i class="fa-solid fa-envelope" style="font-size: 22px; color: white;"></i>
              </div>
            </a>
          </li>

          <!-- <li class="layout-topbar-item" style="margin-right: 2rem">
            <LocaleSwitcher :colorText="true" />
          </li> -->

          <li class="layout-topbar-item">
            <div class="divider" />
            <div class="menu-profile">
              <AppInlineMenu
                v-if="
                  inlineMenuPosition === 'top' || inlineMenuPosition === 'both'
                "
                v-model:active="inlineMenuTopActive"
                @change-inlinemenu="onChangeInlineMenu"
                inlineMenuKey="top"
                :menuMode="menuMode"
              ></AppInlineMenu>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- Mobil tasarım - tamamen farklı basit bir UI -->
    <div v-else class="mobile-topbar-container">
      <!-- Sol tarafta hamburger menü ve logo -->
      <div class="mobile-topbar-left">
        <button class="mobile-menu-btn" @click="onMenuButtonClick">
          <i class="pi pi-bars"></i>
        </button>
        <img loading="lazy" src="/img/logo.png" class="mobile-logo-img-small" alt="CrowdHRs Logo" />
      </div>
      
      <!-- Sağ tarafta temel aksiyonlar -->
      <div class="mobile-topbar-right" v-if="this.loggedIn != null && this.loggedIn">
        <!-- Bildirimler butonu -->
        <button class="mobile-action-btn notification-btn" @click="toggleNotifications($event)">
          <i class="pi pi-bell"></i>
          <span v-if="unreadCount > 0" class="mobile-badge pulse">{{ unreadCount }}</span>
        </button>
        
        <!-- Mesajlar butonu -->
        <button class="mobile-action-btn message-btn" @click="toggleMessages($event)">
          <i class="pi pi-comments"></i>
          <span v-if="unreadMessages > 0" class="mobile-badge pulse">{{ unreadMessages }}</span>
        </button>
        
        <!-- Puanlar görüntüsü -->
        <div v-if="showUserPoints" class="mobile-points">
          <i class="pi pi-star-fill"></i>
          <span>{{ userPoints }}</span>
        </div>
        
        <!-- Profil butonu -->
        <button class="mobile-profile-btn" @click="toggleProfileMenu">
          <Avatar
            v-if="!profileData.profile_picture_path"
            :label="getInitials"
            class="profile-avatar-mobile"
            size="normal"
            shape="circle"
          />
          <Avatar
            v-else
            :image="logoURL + profileData.profile_picture_path"
            class="profile-avatar-mobile"
            size="normal"
            shape="circle"
          />
        </button>
      </div>
      
      <!-- Profil Dropdown Menüsü -->
      <transition name="slide-fade">
        <div v-if="showProfileMenu" class="mobile-profile-menu">
          <!-- Profil Menü Öğeleri -->
          <div class="profile-menu-items">
            <router-link :to="{ name: 'profile' }" class="profile-menu-item" @click="showProfileMenu = false">
              <i class="pi pi-user"></i>
              <span>User Profile</span>
            </router-link>
            <router-link :to="{ name: 'changePassword' }" class="profile-menu-item" @click="showProfileMenu = false">
              <i class="pi pi-lock"></i>
              <span>Change Password</span>
            </router-link>
            <router-link :to="{ name: 'faq' }" class="profile-menu-item" @click="showProfileMenu = false">
              <i class="pi pi-question-circle"></i>
              <span>Help & Support</span>
            </router-link>
            <div class="menu-separator"></div>
            <div class="profile-menu-item logout-item" @click="logoutUser">
              <i class="pi pi-sign-out"></i>
              <span>Logout</span>
            </div>
          </div>
        </div>
      </transition>
      
      <!-- Mobil sayfanın geri kalanını kaplayan karartma -->
      <div v-if="showProfileMenu || showNotifications || showMessages" 
           class="mobile-overlay" 
           @click="closeAllMobileMenus">
      </div>
    </div>
    
    <!-- Mobil bildirim paneli -->
    <transition name="slide-right">
      <div class="mobile-notification-panel mobile-fixed-panel" v-if="showNotifications">
        <div class="mobile-panel-header">
          <h3>
            <i class="pi pi-bell"></i>
            Notifications
          </h3>
          <div class="panel-header-actions">
            <button class="panel-action-btn" @click="markAllAsRead">
              <i class="pi pi-check-circle"></i>
              <span>Mark all read</span>
            </button>
            <button class="mobile-close-btn" @click="showNotifications = false">
              <i class="pi pi-times"></i>
            </button>
        </div>
        </div>
        
        <div class="mobile-panel-content scrollable-content">
          <div v-if="notifications.length === 0" class="empty-state">
            <i class="pi pi-bell-slash empty-icon"></i>
            <p>No notifications yet</p>
          </div>
          
          <div v-else class="mobile-notification-list">
            <div
              v-for="(notification, index) in notifications"
              :key="index"
              class="mobile-notification-item"
              :class="{ unread: !notification.read }"
            >
              <div class="notification-icon" :class="notification.type">
                <i v-if="notification.type === 'mention'" class="pi pi-at"></i>
                <i v-else-if="notification.type === 'task'" class="pi pi-check-square"></i>
                <i v-else-if="notification.type === 'reminder'" class="pi pi-exclamation-triangle"></i>
              </div>
              
              <div class="notification-content">
                <div class="notification-title">
                  <strong>{{ notification.sender || 'System' }}</strong>
                  <span class="notification-time">{{ notification.time }} ago</span>
                </div>
                <div class="notification-body">
                  <p>
                    <span v-if="notification.type === 'mention'">mentioned you at </span>
                    <span v-else-if="notification.type === 'task'">has created new task at </span>
                    <span v-else-if="notification.type === 'reminder'">[REMINDER] Due date of </span>
                    <span class="project-name">{{ notification.project }}</span>
                    <span v-if="notification.details"> - {{ notification.details }}</span>
                  </p>
                </div>
                
                <button v-if="!notification.read" class="mark-read-btn" @click="markAsRead(index)">
                  <i class="pi pi-check"></i>
                  <span>Mark as read</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div class="mobile-panel-footer">
          <button class="view-all-btn" @click="viewAllNotifications">
            <i class="pi pi-list"></i>
            <span>View All Notifications</span>
          </button>
        </div>
      </div>
    </transition>
    
    <!-- Mobil mesaj paneli -->
    <transition name="slide-right">
      <div class="mobile-message-panel mobile-fixed-panel" :class="{ 'active': showMessages && isMobileView }" v-if="showMessages && isMobileView">
        <div class="mobile-panel-header">
          <h3>
            <i class="pi pi-comments"></i>
            Messages
          </h3>
          <button class="mobile-close-btn" @click="showMessages = false">
            <i class="pi pi-times"></i>
          </button>
        </div>
            
        <div class="mobile-panel-content messages-panel-content scrollable-content">
          <div v-if="messages.length === 0" class="empty-state">
            <i class="pi pi-inbox empty-icon"></i>
            <p>No messages yet</p>
          </div>
              
          <div v-else class="mobile-message-list">
            <div
              v-for="(message, index) in messages"
              :key="index"
              class="mobile-message-item"
              :class="{ unread: !message.read }"
              @click="goToConversation(message.id, $event)"
            >
              <div class="message-avatar">
                <img :src="message.avatar" :alt="message.sender" />
                <div class="status-dot" :class="message.status"></div>
              </div>
                  
              <div class="message-preview">
                <div class="message-sender">
                  <strong>{{ message.sender }}</strong>
                </div>
                <p class="message-text-preview">{{ message.text }}</p>
              </div>
              
              <div class="message-time">{{ message.time }}</div>
            </div>
          </div>
        </div>
            
        <div class="mobile-panel-footer">
          <button class="view-all-btn mobile-view-all-btn" @click="viewAllMessages">
            <i class="pi pi-envelope"></i>
            <span>View All Messages</span>
          </button>
        </div>
      </div>
    </transition>
    
    <!-- Desktop Notifications panel using NotificationPanel component -->
    <notification-panel
      v-if="!isMobileView"
      title="Notifications"
      :items="notificationItems"
      :show="showNotifications"
      type="notification"
      class="notifications-dropdown"
      @close="showNotifications = false"
      @mark-all-read="markAllAsRead"
      @clear-all="clearAllNotifications"
    />
    
    <!-- Desktop Messages panel using NotificationPanel component -->
    <notification-panel
      v-if="!isMobileView"
      title="Messages"
      :items="messageItems"
      :show="showMessages"
      type="message"
      class="messages-dropdown"
      @close="showMessages = false"
      @mark-all-read="markAllMessagesAsRead"
      @clear-all="clearAllMessages"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { get, post } from './api/Services'
import AppInlineMenu from './AppInlineMenu.vue'
import { removeItem, setItem } from './store/localStorage'
import { FilterMatchMode, FilterOperator } from 'primevue/api'
import { mapState } from 'vuex'
import { getItem } from './store/localStorage'
import { ref, onBeforeUnmount, onMounted, reactive } from 'vue'
import Avatar from 'primevue/avatar'
import NotificationPanel from './components/NotificationPanel.vue'

export default {
  emits: [
    'menubutton-click',
    'topbar-menubutton-click',
    'topbaritem-click',
    'rightpanel-button-click',
    'topbar-mobileactive',
    'search-click',
    'search-toggle',
  ],
  data() {
    return {
      hamburgerMenuActive: false,
      search: '',
      dashboard: null,
      searchText: '',
      items: [],
      alertCount: 0,
      alertsData: [],
      loggedIn: JSON.parse(getItem('loggeduser')),
      authDeviceTypes: [],
      inlineMenuTopActive: false,
      inlineMenuBottomActive: false,
      menuMode: 'static',
      inlineMenuPosition: 'top',
      filters: null,
      showNotifications: false,
      notificationPanel: null,
      messagePanel: null,
      showProfileMenu: false, // Mobil profil menüsü için yeni state
      isMobileView: false, // Mobil görünüm için state değişkeni
      notifications: [
        {
          type: 'mention',
          sender: 'Jackie Kun',
          project: 'Kleon Projects',
          time: '2m',
          read: false,
        },
        {
          type: 'task',
          sender: 'Olivia Johanna',
          project: 'Kleon Projects',
          time: '2m',
          read: false,
        },
        {
          type: 'reminder',
          project: 'Highspeed Studios Projects',
          details: 'te task will be coming',
          time: '2m',
          read: false,
        },
      ],
      showMessages: false,
      messages: [
        {
          id: 1,
          sender: 'Alex Johnson',
          text: 'Hello, do you have time to discuss the project?',
          time: '5m',
          read: false,
          avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
          status: 'online'
        },
        {
          id: 2,
          sender: 'Emma Williams',
          text: 'I\'ve sent you the files you requested',
          time: '2h',
          read: false,
          avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
          status: 'away'
        },
        {
          id: 3,
          sender: 'Michael Brown',
          text: 'When is our next team meeting?',
          time: '1d',
          read: true,
          avatar: 'https://randomuser.me/api/portraits/men/51.jpg',
          status: 'offline'
        }
      ],
      unreadMessages: 2,
      logoURL: '',
      
      // Transformed notifications for NotificationPanel
      notificationItems: [],
      
      // Transformed messages for NotificationPanel
      messageItems: [],
    }
  },
  mounted() {
    // Logo URL'ini başlangıçta ayarla
    this.logoURL = process.env.VUE_APP_MEDIA_URL || ''
    
    this.getAuthDeviceType()
    
    // Mobil kontrolü için window resize event listener ekle
    this.checkMobileView();
    window.addEventListener('resize', this.checkMobileView);
    
    // Diğer kodlar...
    document.addEventListener('click', this.handleClickOutside)
    
    // Set references for panels
    this.notificationPanel = ref(null)
    this.messagePanel = ref(null)
    
    // Transform notifications and messages for the NotificationPanel format
    this.transformNotificationsAndMessages()
  },
  onBeforeUnmount() {
    // Resize listener'ı kaldır
    window.removeEventListener('resize', this.checkMobileView);
    
    // Diğer kodlar...
    document.removeEventListener('click', this.handleClickOutside)
  },
  props: {
    horizontal: {
      type: Boolean,
      default: false,
    },
    topbarMenuActive: {
      type: Boolean,
      default: false,
    },

    ondocumentclick: {
      type: Function,
    },
    activeTopbarItem: String,
    mobileTopbarActive: Boolean,
    searchActive: Boolean,
  },

  methods: {
    clearFilter() {
      this.initFilters()
    },

    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        'country.name': {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        representative: { value: null, matchMode: FilterMatchMode.IN },
        date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        balance: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        status: {
          operator: FilterOperator.OR,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
        verified: { value: null, matchMode: FilterMatchMode.EQUALS },
      }
    },
    getAlerts() {
      if (this.account.loggeduser != null) {
        if (this.authDeviceTypes != null && this.authDeviceTypes.length > 0) {
          get(
            '/alerts/allActiveAlerts/' +
              this.account.loggeduser.managers_codes +
              '/' +
              this.authDeviceTypes
          ).then((data) => {
            this.alertsData = data
            if (data && this.alertsData.length != 0) {
              this.alertCount = this.alertsData[0]
            }
          })
        }
      }
    },
    onChangeInlineMenu(e, key) {
      if (key === 'top') {
        if (this.inlineMenuBottomActive) {
          this.inlineMenuBottomActive = false
        }
        this.inlineMenuTopActive = !this.inlineMenuTopActive
      }
      if (key === 'bottom') {
        if (this.inlineMenuTopActive) {
          this.inlineMenuTopActive = false
        }
        this.inlineMenuBottomActive = !this.inlineMenuBottomActive
      }

      this.inlineMenuClick = true
    },
    refresh() {
      if (this.account.loggeduser != null) {
        post('/dashboard/main', this.account.loggeduser).then((data) => {
          if (data != undefined && data != null) {
            this.dashboard = data
            setItem('dashboard', JSON.stringify(this.dashboard))
            if (document.getElementById('onlineUser') != undefined) {
              if (this.dashboard.onlineUserCount != null) {
                document.getElementById('onlineUser').textContent =
                  this.dashboard.onlineUserCount
              }
            }
          }
        })
      }
    },
    getAuthDeviceType() {
      var dtCodes = null

      if (this.loggedIn.authorized_device_types) {
        if (this.loggedIn.authorized_device_types.includes(';')) {
          dtCodes = this.loggedIn.authorized_device_types.split(';')

          for (var i = 0; i < dtCodes.length; i++) {
            this.authDeviceTypes.push(dtCodes[i].split('_')[0])
          }
        } else {
          this.authDeviceTypes.push(
            this.loggedIn.authorized_device_types.split('_')[0]
          )
        }
      }
    },
    logoutUser() {
      removeItem('loggeduser')
      this.$router.push({ name: 'login' })
    },

    // Handle click outside notification or message panel
    handleClickOutside(event) {
      // For notifications
      const notificationBtn = document.querySelector('a[aria-label="Notifications"]');
      const notificationPanel = document.querySelector('.notification-panel');
      
      if (
        this.showNotifications &&
        notificationPanel &&
        !notificationPanel.contains(event.target) &&
        notificationBtn &&
        !notificationBtn.contains(event.target)
      ) {
        this.showNotifications = false;
      }
      
      // For messages
      const messageBtn = document.querySelector('a[aria-label="Messages"]');
      const messagePanel = document.querySelector('.message-panel');
      
      if (
        this.showMessages &&
        messagePanel &&
        !messagePanel.contains(event.target) &&
        messageBtn &&
        !messageBtn.contains(event.target)
      ) {
        this.showMessages = false;
      }
      
      // For profile menu
      const profileBtn = document.querySelector('.menu-profile');
      const profileMenu = document.querySelector('.menu-list');
      
      if (
        this.inlineMenuTopActive &&
        profileMenu &&
        !profileMenu.contains(event.target) &&
        profileBtn &&
        !profileBtn.contains(event.target) &&
        !this.inlineMenuClick
      ) {
        this.inlineMenuTopActive = false;
      }
      
      this.inlineMenuClick = false;
    },

    // Toggle notifications
    toggleNotifications(event) {
      event.stopPropagation();
      
      // Close messages panel if open
      if (this.showMessages) {
        this.showMessages = false;
      }
      
      // Close profile menu if open
      if (this.showProfileMenu) {
        this.showProfileMenu = false;
      }
      
      this.showNotifications = !this.showNotifications;
    },

    // Mark a notification as read without closing panel
    markAsRead(index) {
      this.notifications[index].read = true;
      event.stopPropagation(); // Prevent panel closing
    },

    // Mark all notifications as read
    markAllAsRead() {
      this.notifications.forEach((notification) => {
        notification.read = true
      })
      this.transformNotificationsAndMessages();
    },

    // View all notifications
    viewAllNotifications() {
      // Close the panel first to prevent overlapping
      this.showNotifications = false;
      
      // Navigate to notifications page
      this.$router.push({ name: 'notifications' });
    },

    ...mapActions('account', ['logout']),
    onSearchContainerClick(event) {
      this.$emit('search-click', event)
    },
    changeSearchActive(event) {
      this.$emit('search-toggle', event)
    },
    onMenuButtonClick(event) {
      this.$emit('menubutton-click', event)
    },
    onTopbarMenuButtonClick(event) {
      this.$emit('topbar-menubutton-click', event)
    },
    onTopbarItemClick(event, item) {
      switch (item) {
        case 'notifications':
          this.showNotifications = !this.showNotifications
          break
        case 'messages':
          this.showMessages = !this.showMessages
          break
        default:
          break
      }
      this.$emit('topbaritem-click', { originalEvent: event, item: item })
    },
    onTopbarMobileButtonClick(event) {
      this.$emit('topbar-mobileactive', event)
    },
    onRightPanelButtonClick(event) {
      this.$emit('rightpanel-button-click', event)
    },
    onSearchKeydown(event) {
      if (event.keyCode == 13) {
        this.$emit('search-toggle', event)
      }
    },
    onEnter() {
      if (this.$refs.searchInput) {
        this.$refs.searchInput.$el.focus()
      }
    },
    toggleMessages(event) {
      event.stopPropagation();
      
      // Close notifications panel if open
      if (this.showNotifications) {
        this.showNotifications = false;
      }
      
      // Close profile menu if open
      if (this.showProfileMenu) {
        this.showProfileMenu = false;
      }
      
      this.showMessages = !this.showMessages;
    },
    viewAllMessages() {
      // Close the panel first to prevent overlapping
      this.showMessages = false;
      
      // Navigate to messages page
      this.$router.push({ name: 'messages' });
    },
    goToConversation(id, event) {
      if (event) {
        event.stopPropagation();
      }
      this.$router.push({ name: 'messages' });
      // Don't close the messages panel
    },
    toggleProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
      
      // Diğer açık menüleri kapat
      if (this.showProfileMenu) {
        this.showNotifications = false;
        this.showMessages = false;
      }
    },
    // Mobil görünüm kontrolü için metod
    checkMobileView() {
      const wasMobile = this.isMobileView;
      this.isMobileView = window.innerWidth <= 991;
      
      // If view type changes, close all menus to prevent conflicts
      if (wasMobile !== this.isMobileView) {
        this.closeAllPanels();
      }
    },
    closeAllMobileMenus() {
      this.showProfileMenu = false;
      this.showNotifications = false;
      this.showMessages = false;
    },
    // Add method to close all desktop panels
    closeAllDesktopPanels() {
      this.showNotifications = false;
      this.showMessages = false;
    },
    // Method to close all panels
    closeAllPanels() {
      this.showNotifications = false;
      this.showMessages = false;
      this.showProfileMenu = false;
      this.inlineMenuTopActive = false;
    },
    
    markAllMessagesAsRead() {
      // Mark all messages as read
      this.messages.forEach(message => {
        message.read = true;
      });
      this.unreadMessages = 0;
      this.transformNotificationsAndMessages();
    },
    
    markMessageAsRead(index) {
      if (!this.messages[index].read) {
        this.messages[index].read = true;
        this.unreadMessages = Math.max(0, this.unreadMessages - 1);
      }
    },
    
    // Transform notifications to the format expected by NotificationPanel
    transformNotificationsAndMessages() {
      // Transform notifications
      this.notificationItems = this.notifications.map(notification => {
        let icon = null;
        
        // Map notification types to icons
        switch (notification.type) {
          case 'mention':
            icon = 'fa-solid fa-at';
            break;
          case 'task':
            icon = 'fa-solid fa-tasks';
            break;
          case 'reminder':
            icon = 'fa-solid fa-bell';
            break;
          default:
            icon = 'fa-solid fa-bell';
        }
        
        return {
          title: notification.sender || 'Notification',
          label: notification.project,
          time: notification.time,
          isNew: !notification.read,
          icon: icon,
          type: notification.type
        }
      });
      
      // Transform messages
      this.messageItems = this.messages.map(message => {
        return {
          title: message.sender,
          label: message.text,
          time: message.time,
          isNew: !message.read,
          avatar: message.avatar,
          type: 'message',
          action: {
            icon: 'fa-solid fa-reply',
            handler: () => this.goToConversation(message.id)
          }
        }
      });
    },
    
    // Clear all notifications
    clearAllNotifications() {
      this.notifications = [];
      this.transformNotificationsAndMessages();
    },
    
    // Clear all messages
    clearAllMessages() {
      this.messages = [];
      this.unreadMessages = 0;
      this.transformNotificationsAndMessages();
    },
  },
  created() {
    this.initFilters()
  },

  computed: {
    topbarItemsClass() {
      return [
        'topbar-items animated fadeInDown',
        {
          'topbar-items-visible': this.topbarMenuActive,
        },
      ]
    },
    isRTL() {
      return this.$appState.RTL
    },
    unreadCount() {
      return this.notifications.filter((n) => !n.read).length
    },
    ...mapState({
      account: (state) => state.account,
    }),
    showUserPoints() {
      return (
        this.account &&
        this.account.userParam &&
        this.account.userParam.id === 2 &&
        this.account.userParam.points !== undefined
      )
    },
    userPoints() {
      return this.account &&
        this.account.userParam &&
        this.account.userParam.points
        ? this.account.userParam.points
        : 0
    },
    // Profil bilgilerini userParam'dan al - mobil avatar için gerekli
    profileData() {
      // userParam null değilse verileri al, değilse boş değerler döndür
      if (!this.account || !this.account.userParam) {
        return {
          firstname: '',
          lastname: '',
          role_name: '',
          profile_picture_path: '',
          points: 0,
        }
      }

      return {
        firstname: this.account.userParam.firstname || '',
        lastname: this.account.userParam.lastname || '',
        role_name: this.account.userParam.role_name || '',
        profile_picture_path: this.account.userParam.profile_picture_path || '',
        points: this.account.userParam.points || 0,
      }
    },
    // Avatar için baş harfleri al
    getInitials() {
      if (!this.profileData.firstname || !this.profileData.lastname) {
        return '';
      }
      
      return (
        (this.profileData.firstname[0]?.toUpperCase() || '') +
        (this.profileData.lastname[0]?.toUpperCase() || '')
      );
    },
  },
  components: {
    AppInlineMenu,
    Avatar,
    NotificationPanel
  },
}
</script>

<style lang="scss" scoped>
/* Main Topbar Styles */
.layout-topbar {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  transition: all 0.3s ease;
  padding: 0.5rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  backdrop-filter: blur(10px);
  height: var(--topbar-height, 56px);
}

.notification-container, .messages-container {
  position: relative;
  display: inline-block;
}

.sticky-topbar {
  position: sticky;
  top: 0;
  width: 100%;
}

.layout-topbar-right {
  flex: 1;
  display: flex;
  height: 100% !important;
  justify-content: space-between;
  align-items: center;
}

/* Redesigned Mobile Logo Styles */
.mobile-logo {
  display: flex;
  align-items: center;
}

.mobile-logo .pointer {
  cursor: pointer;
}

.mobile-logo-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 3px 8px;
  transition: all 0.3s ease;
  gap: 8px;
}

.mobile-logo-container:hover {
  background: rgba(255, 255, 255, 0.2);
}

.mobile-logo-img {
  height: 28px;
  width: auto;
  transition: all 0.3s ease;
}

.mobile-menu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
}

.mobile-menu-icon i {
  color: white;
  font-size: 0.9rem;
}

.mobile-logo-container:hover .mobile-menu-icon {
  background: rgba(255, 255, 255, 0.25);
}

/* Topbar Actions */
.layout-topbar-actions-right {
  display: flex;
  height: 100%;
    align-items: center;
  justify-content: flex-end;
  height: 100%;
  gap: 12px;
}

.layout-topbar-items {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.layout-topbar-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.layout-topbar-action {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin: 0 4px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.12);
  color: white;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.layout-topbar-action:hover {
  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Adjust icon sizes for better consistency */
.layout-topbar-action svg {
  width: 22px !important;
  height: 22px !important;
  fill: white !important;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
}

.layout-topbar-action .pi-home {
  font-size: 1.3rem;
}

.layout-topbar-action .pi-bell,
.layout-topbar-action .pi-comments {
  font-size: 1.25rem;
}

.home-button:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.notification-button:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.messages-button:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.divider {
  width: 1px;
  height: 28px;
  background: rgba(255, 255, 255, 0.2);
  margin: 0 10px;
}

/* Icon styles in notifications/messages */
.notification-icon, .message-icon {
  margin-right: 6px;
  color: var(--primary-color);
  font-size: 0.9rem;
}

.notification-reminder i {
  margin-top: 2px;
  font-size: 1.1rem;
  color: var(--orange-500);
}

.mr-1 {
  margin-right: 4px;
}

.mr-2 {
  margin-right: 8px;
}

/* Points Display Styles */
.points-display {
  display: flex;
  align-items: center;
  margin-right: 6px;
}

.points-container {
  display: flex;
  align-items: center;
  background: linear-gradient(
    135deg,
    rgba(255, 215, 0, 0.15) 0%,
    rgba(255, 165, 0, 0.15) 100%
  );
  padding: 4px 8px;
  border-radius: 16px;
  border: 1px solid rgba(255, 215, 0, 0.3);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.points-container:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  background: linear-gradient(
    135deg,
    rgba(255, 215, 0, 0.25) 0%,
    rgba(255, 165, 0, 0.25) 100%
  );
}

.points-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #ffd700 0%, #ffa500 100%);
  border-radius: 50%;
  margin-right: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.points-icon-wrapper i {
  color: #fff;
  font-size: 12px;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
}

.points-value {
  color: #ffd700;
  font-weight: 700;
  font-size: 14px;
  margin-right: 4px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.points-label {
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  opacity: 0.9;
}

.badge-counter {
  position: absolute;
  top: -4px;
  right: -4px;
  background-color: #ffffff;
  color: #4d94d2;
  font-size: 11px;
  font-weight: 600;
  min-width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 2px solid #4d94d2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Badge container styling */
.badge-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

/* Notification Panel Styles */
.notification-container {
  position: relative;
}

.notification-panel {
  position: absolute;
  top: 45px;
  right: -60px;
  width: 300px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 1001; /* Increased z-index */
  overflow: hidden;
  animation: fadeIn 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e8eef3;
  background-color: var(--surface-card, #ffffff);
}

.notification-header h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--primary-color, #3B82F6);
  margin: 0;
  display: flex;
  align-items: center;
}

.notification-header h3 i {
  color: var(--primary-color, #3B82F6);
  animation: none;
}

@keyframes bellShake {
  0% { transform: rotate(0); }
  5% { transform: rotate(0); }
  10% { transform: rotate(0); }
  15% { transform: rotate(0); }
  100% { transform: rotate(0); }
}

.notification-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.mark-all-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: var(--text-color-secondary, #64748b);
  font-size: 0.85rem;
  cursor: pointer;
  transition: color 0.2s;
  padding: 5px 8px;
  border-radius: 8px;
}

.mark-all-btn:hover {
  color: var(--primary-color, #3B82F6);
  background: var(--surface-hover, #f1f5f9);
}

.panel-menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: transparent;
  border: none;
  color: var(--text-color-secondary, #64748b);
  cursor: pointer;
  transition: all 0.2s;
}

.panel-menu-btn:hover {
  background: var(--surface-hover, #f1f5f9);
  color: var(--primary-color, #3B82F6);
}

.notification-list {
  max-height: 400px;
  overflow-y: auto;
  padding: 0;
  background-color: var(--surface-card, #ffffff);
}

.notification-item {
  padding: 16px 20px;
  border-bottom: 1px solid #e8eef3;
  transition: all 0.2s;
  position: relative;
  border-left: 0px solid var(--primary-color, #3B82F6);
}

.notification-item:hover {
  background-color: var(--surface-hover, #f8fafc);
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-item.unread {
  background-color: var(--surface-hover, #f0f7ff);
  border-left: 4px solid var(--primary-color, #3B82F6);
}

.notification-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.notification-text {
  font-size: 0.95rem;
  color: var(--text-color, #334155);
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
}

.notification-text strong {
  font-weight: 600;
  color: var(--text-color, #1e293b);
}

.project-name {
  color: var(--primary-color-darker, #f97316);
  font-weight: 500;
}

.notification-time {
  font-size: 0.8rem;
  color: var(--text-color-secondary, #94a3b8);
  display: flex;
  align-items: center;
}

.notification-reminder {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: var(--text-color, #334155);
  font-size: 0.95rem;
  line-height: 1.5;
}

.mark-read-btn {
  margin-top: 10px;
  background: transparent;
  border: 1px solid var(--primary-color, #3B82F6);
  color: var(--primary-color, #3B82F6);
  font-size: 0.85rem;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  width: fit-content;
}

.mark-read-btn:hover {
  background: var(--primary-color, #3B82F6);
  color: white;
}

.notification-footer {
  padding: 14px 20px;
  background: var(--surface-section, #f8fafc);
  border-top: 1px solid #e8eef3;
  display: flex;
  justify-content: center;
}

.view-all-btn {
  width: 100%;
  padding: 10px;
  background: #fff;
  border: 1px solid var(--surface-border, #e2e8f0);
  border-radius: 8px;
  color: var(--primary-color, #3B82F6);
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.view-all-btn:hover {
  background: var(--primary-color, #3B82F6);
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.view-all-btn:hover i {
  animation: none;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Scrollbar styling for notification list */
.notification-list::-webkit-scrollbar,
.message-list::-webkit-scrollbar {
  width: 6px;
}

.notification-list::-webkit-scrollbar-track,
.message-list::-webkit-scrollbar-track {
  background: var(--surface-ground, #f1f5f9);
  border-radius: 3px;
}

.notification-list::-webkit-scrollbar-thumb,
.message-list::-webkit-scrollbar-thumb {
  background: var(--surface-border, #cbd5e1);
  border-radius: 3px;
}

.notification-list::-webkit-scrollbar-thumb:hover,
.message-list::-webkit-scrollbar-thumb:hover {
  background: var(--text-color-secondary, #94a3b8);
}

/* Responsive styles - Improved for better mobile experience */
@media (max-width: 992px) {
  .layout-topbar {
    padding: 0.3rem 0.7rem;
  }
}

@media (max-width: 768px) {
  .layout-topbar-items {
    gap: 2px;
  }
  
  .layout-topbar-action {
    width: 28px;
    height: 28px;
    margin: 0;
  }
  
  .layout-topbar-action svg {
    width: 16px !important;
    height: 16px !important;
  }
  
  .divider {
    margin: 0 4px;
    height: 20px;
  }
  
  .mobile-logo-container {
    padding: 3px 5px;
  }
  
  .notification-panel,
  .message-panel {
    width: 280px;
    right: -70px;
    top: 40px;
  }
  
  .notification-panel::before,
  .message-panel::before {
    right: 75px;
  }
  
  .badge-counter {
    width: 16px;
    height: 16px;
    font-size: 9px;
    top: -5px;
    right: -5px;
  }
}

@media (max-width: 480px) {
  .layout-topbar {
    padding: 0.2rem 0.5rem;
    height: 50px;
  }
  
  .layout-topbar-items {
    gap: 1px;
  }
  
  .mobile-logo-img {
    height: 22px;
  }
  
  .mobile-menu-icon {
    width: 24px;
    height: 24px;
  }
  
  .layout-topbar-action {
    width: 26px;
    height: 26px;
  }
  
  .notification-panel,
  .message-panel {
    width: 260px;
    right: -80px;
  }
  
.notification-panel::before,
.message-panel::before {
    right: 85px;
  }
  
  .points-container {
    padding: 3px 6px;
  }
  
  .points-value {
    font-size: 12px;
  }
  
  .points-icon-wrapper {
    width: 18px;
    height: 18px;
    margin-right: 4px;
  }
  
  .points-icon-wrapper i {
    font-size: 10px;
  }
  
  .divider {
  height: 16px;
  }
  
  /* Collapse extra elements for very small screens */
  .hide-on-xsmall {
    display: none !important;
  }
  
  /* Make dropdowns full width on very small screens */
  .notification-panel,
.message-panel {
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 100%;
    border-radius: 0;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    height: calc(100vh - 50px);
    max-height: calc(100vh - 50px);
  }
  
  .notification-panel::before,
  .message-panel::before {
    display: none;
  }
  
  .notification-list,
  .message-list {
    max-height: calc(100vh - 150px);
  }
}

/* Add support for smaller screens */
@media (max-width: 360px) {
  .layout-topbar {
    padding: 0.2rem 0.4rem;
  }
  
  .mobile-logo-img {
    height: 20px;
  }
  
  .mobile-logo-container {
    padding: 2px 4px;
    gap: 4px;
  }
  
  .mobile-menu-icon {
    width: 22px;
    height: 22px;
  }
}

.layout-topbar-mobile-active {
  flex-direction: column;
  align-items: flex-start;
}

/* Fix for notification/message panels in all screen sizes */
.notification-panel, 
.message-panel {
  z-index: 1000;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
}

/* Add dark overlay for better contrast when panels are open on mobile */
@media (max-width: 480px) {
  .dark-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
}

/* Mobil tasarım için yeni stiller */
.mobile-topbar {
  background: linear-gradient(90deg, #003e75, #4d94d2);
  height: 56px;
  padding: 0;
}

.mobile-topbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 10px;
}

.mobile-topbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mobile-topbar-right {
  display: flex;
  align-items: center;
  gap: 5px;
  position: relative;
}

.mobile-menu-btn {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
}

.mobile-menu-btn:hover {
  background: rgba(255, 255, 255, 0.25);
}

.mobile-menu-btn i {
  color: white;
  font-size: 20px;
}

.mobile-logo-img-small {
  height: 26px;
  width: auto;
}

.mobile-action-btn {
  background: rgba(255, 255, 255, 0.12);
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  color: white;
  transition: all 0.2s;
  text-decoration: none;
}

.mobile-action-btn:hover, .mobile-action-btn:active {
  background: rgba(255, 255, 255, 0.22);
}

.mobile-action-btn i {
  color: white;
  font-size: 16px;
}

.mobile-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ffffff;
  color: #003e75;
  font-size: 10px;
  font-weight: bold;
  height: 18px;
  min-width: 18px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 2px solid #003e75;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.profile-btn {
  background: rgba(255, 255, 255, 0.25);
}

.profile-dropdown {
  position: absolute;
  top: 48px;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 180px;
  z-index: 1000;
  overflow: hidden;
  animation: fadeInDown 0.3s;
}

.profile-dropdown-item {
  padding: 12px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.profile-dropdown-item:hover {
  background: #f5f8ff;
}

.profile-dropdown-item i {
  color: #003e75;
  font-size: 16px;
}

.profile-dropdown-item span {
  color: #333;
  font-size: 14px;
}

/* Mobil bildirim ve mesaj panelleri */
.mobile-notification-panel {
  position: fixed;
  top: 56px;
  left: 0;
  height: calc(100% - 56px);
  width: 100%;
  background: white;
  z-index: 1002; /* Even higher z-index for mobile */
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}

.mobile-message-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mobile-message-item {
  display: flex;
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
  align-items: center;
}

.mobile-message-item.unread {
  background-color: rgba(59, 130, 246, 0.04);
  border-left: 3px solid #4d94d2;
}

.mobile-message-item:active {
  background-color: rgba(59, 130, 246, 0.08);
}

.message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
  position: relative;
  flex-shrink: 0;
}

.message-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.status-dot {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid white;
  z-index: 1;
}

.message-preview {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  position: relative;
  padding-right: 45px; /* Make room for the time */
}

.message-sender {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 5px;
}

.message-sender strong {
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.message-time {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 12px;
  color: #94a3b8;
  white-space: nowrap;
}

.message-text-preview {
  color: #64748b;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
}

.mobile-close-btn {
  background: transparent;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  cursor: pointer;
}

.mobile-close-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}

@media screen and (max-width: 991px) {
  .mobile-notification-panel,
  .mobile-message-panel {
    position: fixed;
    top: 56px; /* Start just below the topbar */
    left: 0;
    width: 100%;
    height: calc(100vh - 56px);
    max-width: 100%;
    max-height: calc(100vh - 56px);
    border-radius: 0;
    z-index: 1001;
  }
}

.mobile-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid #eee;
  background: #f9f9f9;
}

.mobile-panel-header h3 {
  margin: 0;
  font-size: 18px;
  color: #003e75;
}

.mobile-close-btn {
  background: none;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.mobile-close-btn i {
  color: #666;
  font-size: 18px;
}

.mobile-notification-list,
.mobile-message-list {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

.mobile-notification-item,
.mobile-message-item {
  background: white;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  border-left: 3px solid transparent;
}

.mobile-notification-item.unread,
.mobile-message-item.unread {
  border-left-color: #4d94d2;
  background: #f5f9ff;
}

.notification-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.notification-time {
  font-size: 12px;
  color: #888;
}

.notification-body {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.mark-read-btn-mobile {
  background: #4d94d2;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
}

.profile-avatar-mobile {
  width: 100%;
  height: 100%;
  border: 2px solid rgba(255, 255, 255, 0.3);
  font-size: 14px !important;
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
}

.profile-dropdown-item.danger-item {
  color: #dc3545;
}

.profile-dropdown-item.danger-item i,
.profile-dropdown-item.danger-item span {
  color: #dc3545;
}

.profile-dropdown-item.danger-item:hover {
  background-color: rgba(220, 53, 69, 0.08);
}

.profile-dropdown {
  z-index: 1001;
}

/* isMobile metodu için kısaltma - bu metod script içinde var */
@media (max-width: 991px) {
  .hide-on-small {
    display: none;
  }
}

.notification-icon {
  margin-right: 10px;
  font-size: 1.2rem;
  color: var(--primary-color);
}

.notification-content {
  display: flex;
  align-items: center;
}

.notification-title {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.notification-body {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.mark-read-btn {
  background: transparent;
  border: none;
  color: var(--primary-color);
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  width: fit-content;
}

.mark-read-btn:hover {
  color: var(--primary-color);
}

.notification-footer {
  padding: 14px 20px;
  background: var(--surface-section, #f8fafc);
  border-top: 1px solid #e8eef3;
  display: flex;
  justify-content: center;
}

.notification-panel {
  position: absolute;
  top: 45px;
  right: -60px;
  width: 300px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 1001; /* Increased z-index */
  overflow: hidden;
  animation: fadeIn 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e8eef3;
  background-color: var(--surface-card, #ffffff);
}

.notification-header h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--primary-color, #3B82F6);
  margin: 0;
  display: flex;
  align-items: center;
}

.notification-header h3 i {
  color: var(--primary-color, #3B82F6);
}

@keyframes bellShake {
  0% { transform: rotate(0); }
  5% { transform: rotate(0); }
  10% { transform: rotate(0); }
  15% { transform: rotate(0); }
  100% { transform: rotate(0); }
}

.notification-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.mark-all-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: var(--text-color-secondary, #64748b);
  font-size: 0.85rem;
  cursor: pointer;
  transition: color 0.2s;
  padding: 5px 8px;
  border-radius: 8px;
}

.mark-all-btn:hover {
  color: var(--primary-color, #3B82F6);
  background: var(--surface-hover, #f1f5f9);
}

.panel-menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: transparent;
  border: none;
  color: var(--text-color-secondary, #64748b);
  cursor: pointer;
  transition: all 0.2s;
}

.panel-menu-btn:hover {
  background: var(--surface-hover, #f1f5f9);
  color: var(--primary-color, #3B82F6);
}

.notification-list {
  max-height: 400px;
  overflow-y: auto;
  padding: 0;
  background-color: var(--surface-card, #ffffff);
}

.notification-item {
  padding: 16px 20px;
  border-bottom: 1px solid #e8eef3;
  transition: all 0.2s;
  position: relative;
  border-left: 0px solid var(--primary-color, #3B82F6);
}

.notification-item:hover {
  background-color: var(--surface-hover, #f8fafc);
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-item.unread {
  background-color: var(--surface-hover, #f0f7ff);
  border-left: 4px solid var(--primary-color, #3B82F6);
}

.notification-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.notification-text {
  font-size: 0.95rem;
  color: var(--text-color, #334155);
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
}

.notification-text strong {
  font-weight: 600;
  color: var(--text-color, #1e293b);
}

.project-name {
  color: var(--primary-color-darker, #f97316);
  font-weight: 500;
}

.notification-time {
  font-size: 0.8rem;
  color: var(--text-color-secondary, #94a3b8);
  display: flex;
  align-items: center;
}

.notification-reminder {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: var(--text-color, #334155);
  font-size: 0.95rem;
  line-height: 1.5;
}

.mark-read-btn {
  margin-top: 10px;
  background: transparent;
  border: 1px solid var(--primary-color, #3B82F6);
  color: var(--primary-color, #3B82F6);
  font-size: 0.85rem;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  width: fit-content;
}

.mark-read-btn:hover {
  background: var(--primary-color, #3B82F6);
  color: white;
}

.notification-footer {
  padding: 14px 20px;
  background: var(--surface-section, #f8fafc);
  border-top: 1px solid #e8eef3;
  display: flex;
  justify-content: center;
}

.view-all-btn {
  width: 100%;
  padding: 10px;
  background: #fff;
  border: 1px solid var(--surface-border, #e2e8f0);
  border-radius: 8px;
  color: var(--primary-color, #3B82F6);
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.view-all-btn:hover {
  background: var(--primary-color, #3B82F6);
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.view-all-btn:hover i {
  animation: none;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Scrollbar styling for notification list */
.notification-list::-webkit-scrollbar,
.message-list::-webkit-scrollbar {
  width: 6px;
}

.notification-list::-webkit-scrollbar-track,
.message-list::-webkit-scrollbar-track {
  background: var(--surface-ground, #f1f5f9);
  border-radius: 3px;
}

.notification-list::-webkit-scrollbar-thumb,
.message-list::-webkit-scrollbar-thumb {
  background: var(--surface-border, #cbd5e1);
  border-radius: 3px;
}

.notification-list::-webkit-scrollbar-thumb:hover,
.message-list::-webkit-scrollbar-thumb:hover {
  background: var(--text-color-secondary, #94a3b8);
}

/* Responsive styles - Improved for better mobile experience */
@media (max-width: 992px) {
  .layout-topbar {
    padding: 0.3rem 0.7rem;
  }
}

@media (max-width: 768px) {
  .layout-topbar-items {
    gap: 2px;
  }
  
  .layout-topbar-action {
    width: 28px;
    height: 28px;
    margin: 0;
  }
  
  .layout-topbar-action svg {
    width: 16px !important;
    height: 16px !important;
  }
  
  .divider {
    margin: 0 4px;
    height: 20px;
  }
  
  .mobile-logo-container {
    padding: 3px 5px;
  }
  
  .notification-panel,
  .message-panel {
    width: 280px;
    right: -70px;
    top: 40px;
  }
  
  .notification-panel::before,
  .message-panel::before {
    right: 75px;
  }
  
  .badge-counter {
    width: 16px;
    height: 16px;
    font-size: 9px;
    top: -5px;
    right: -5px;
  }
}

@media (max-width: 480px) {
  .layout-topbar {
    padding: 0.2rem 0.5rem;
    height: 50px;
  }
  
  .layout-topbar-items {
    gap: 1px;
  }
  
  .mobile-logo-img {
    height: 22px;
  }
  
  .mobile-menu-icon {
    width: 24px;
    height: 24px;
  }
  
  .layout-topbar-action {
    width: 26px;
    height: 26px;
  }
  
  .notification-panel,
  .message-panel {
    width: 260px;
    right: -80px;
  }
  
  .notification-panel::before,
  .message-panel::before {
    right: 85px;
  }
  
  .points-container {
    padding: 3px 6px;
  }
  
  .points-value {
    font-size: 12px;
  }
  
  .points-icon-wrapper {
    width: 18px;
    height: 18px;
    margin-right: 4px;
  }
  
  .points-icon-wrapper i {
    font-size: 10px;
  }
  
  .divider {
    height: 16px;
  }
  
  /* Collapse extra elements for very small screens */
  .hide-on-xsmall {
    display: none !important;
  }
  
  /* Make dropdowns full width on very small screens */
  .notification-panel,
  .message-panel {
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 100%;
    border-radius: 0;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    height: calc(100vh - 50px);
    max-height: calc(100vh - 50px);
  }
  
  .notification-panel::before,
  .message-panel::before {
    display: none;
  }
  
  .notification-list,
  .message-list {
    max-height: calc(100vh - 150px);
  }
}

/* Add support for smaller screens */
@media (max-width: 360px) {
  .layout-topbar {
    padding: 0.2rem 0.4rem;
  }
  
  .mobile-logo-img {
    height: 20px;
  }
  
  .mobile-logo-container {
    padding: 2px 4px;
    gap: 4px;
  }
  
  .mobile-menu-icon {
    width: 22px;
    height: 22px;
  }
}

.layout-topbar-mobile-active {
  flex-direction: column;
  align-items: flex-start;
}

/* Fix for notification/message panels in all screen sizes */
.notification-panel, 
.message-panel {
  z-index: 1000;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
}

/* Add dark overlay for better contrast when panels are open on mobile */
@media (max-width: 480px) {
  .dark-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
}

/* Mobil tasarım için yeni stiller */
.mobile-topbar {
  background: linear-gradient(90deg, #003e75, #4d94d2);
  height: 56px;
  padding: 0;
}

.mobile-topbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 10px;
}

.mobile-topbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mobile-topbar-right {
  display: flex;
  align-items: center;
  gap: 5px;
  position: relative;
}

.mobile-menu-btn {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
}

.mobile-menu-btn:hover {
  background: rgba(255, 255, 255, 0.25);
}

.mobile-menu-btn i {
  color: white;
  font-size: 20px;
}

.mobile-logo-img-small {
  height: 26px;
  width: auto;
}

.mobile-action-btn {
  background: rgba(255, 255, 255, 0.12);
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  color: white;
  transition: all 0.2s;
  text-decoration: none;
}

.mobile-action-btn:hover, .mobile-action-btn:active {
  background: rgba(255, 255, 255, 0.22);
}

.mobile-action-btn i {
  color: white;
  font-size: 16px;
}

.mobile-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ffffff;
  color: #003e75;
  font-size: 10px;
  font-weight: bold;
  height: 18px;
  min-width: 18px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 2px solid #003e75;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.profile-btn {
  background: rgba(255, 255, 255, 0.25);
}

.profile-dropdown {
  position: absolute;
  top: 48px;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 180px;
  z-index: 1000;
  overflow: hidden;
  animation: fadeInDown 0.3s;
}

.profile-dropdown-item {
  padding: 12px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.profile-dropdown-item:hover {
  background: #f5f8ff;
}

.profile-dropdown-item i {
  color: #003e75;
  font-size: 16px;
}

.profile-dropdown-item span {
  color: #333;
  font-size: 14px;
}

/* Mobil bildirim ve mesaj panelleri */
.mobile-notification-panel,
.mobile-message-panel {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 1002; /* Even higher z-index for mobile */
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s;
}

.mobile-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid #eee;
  background: #f9f9f9;
}

.mobile-panel-header h3 {
  margin: 0;
  font-size: 18px;
  color: #003e75;
}

.mobile-close-btn {
  background: none;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.mobile-close-btn i {
  color: #666;
  font-size: 18px;
}

.mobile-notification-list,
.mobile-message-list {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

.mobile-notification-item,
.mobile-message-item {
  background: white;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  border-left: 3px solid transparent;
}

.mobile-notification-item.unread,
.mobile-message-item.unread {
  border-left-color: #4d94d2;
  background: #f5f9ff;
}

.notification-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.notification-time {
  font-size: 12px;
  color: #888;
}

.notification-body {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.mark-read-btn-mobile {
  background: #4d94d2;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
}

.message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}

.message-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mobile-message-item {
  display: flex;
  align-items: center;
}

.message-preview {
  flex: 1;
}

.message-sender {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.message-text-preview {
  font-size: 13px;
  color: #666;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* isMobile metodu için kısaltma - bu metod script içinde var */
@media (max-width: 991px) {
  .hide-on-small {
    display: none;
  }
}

.profile-avatar-mobile {
  width: 100%;
  height: 100%;
  border: 2px solid rgba(255, 255, 255, 0.3);
  font-size: 14px !important;
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
}

.profile-dropdown-item.danger-item {
  color: #dc3545;
}

.profile-dropdown-item.danger-item i,
.profile-dropdown-item.danger-item span {
  color: #dc3545;
}

.profile-dropdown-item.danger-item:hover {
  background-color: rgba(220, 53, 69, 0.08);
}

.profile-dropdown {
  z-index: 1001;
}

/* isMobile metodu için kısaltma - bu metod script içinde var */
@media (max-width: 991px) {
  .hide-on-small {
    display: none;
  }
}

/* Profil Dropdown Mobile */
.mobile-profile-menu {
  position: absolute;
  top: 56px;
  right: 10px;
  width: 300px;
  z-index: 1000;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background-color: white;
  overflow: hidden;
  animation: none;
}

.mobile-profile-btn {
  background: rgba(255, 255, 255, 0.18);
  border: none;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
}

.profile-menu-header {
  display: flex;
  padding: 16px;
  background: linear-gradient(135deg, #003e75, #2980b9);
  color: white;
  position: relative;
}

.profile-header-avatar {
  margin-right: 15px;
}

.profile-header-img {
  width: 60px !important;
  height: 60px !important;
  border: 3px solid rgba(255, 255, 255, 0.5);
}

.profile-header-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.profile-name {
  margin: 0 0 5px 0;
  font-size: 18px;
  font-weight: 600;
}

.profile-role {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 8px;
}

.profile-points {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 8px;
  border-radius: 100px;
  width: fit-content;
}

.close-profile-menu {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.2);
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
}

.profile-menu-items {
  padding: 10px 0;
  overflow-y: auto;
}

.profile-menu-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #333;
  text-decoration: none;
  transition: background 0.2s;
  font-size: 16px;
}

.profile-menu-item:hover {
  background: #f5f8ff;
}

.profile-menu-item i {
  margin-right: 15px;
  font-size: 18px;
  width: 20px;
  color: #4d94d2;
}

.menu-separator {
  height: 1px;
  background: #eee;
  margin: 10px 0;
}

.logout-item {
  color: #e74c3c;
}

.logout-item i {
  color: #e74c3c;
}

.mobile-points {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 100px;
  padding: 3px 8px;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: white;
}

/* Overlays */
.mobile-overlay {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

/* Panel style improvements */
.mobile-panel-content {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  background: #f5f7fa;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 20px;
  color: #94a3b8;
}

.empty-icon {
  font-size: 40px;
  margin-bottom: 15px;
  opacity: 0.5;
}

.panel-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mobile-panel-footer {
  padding: 15px;
  border-top: 1px solid #eee;
  background: white;
  position: sticky;
  bottom: 0;
  z-index: 2;
}

.highlight {
  color: #003e75;
  font-weight: 500;
}

.notification-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f0f7ff;
  color: #4d94d2;
}

.notification-icon.mention {
  background: #f0f7ff; 
  color: #4d94d2;
}

.notification-icon.task {
  background: #f0fff7;
  color: #10b981;
}

.notification-icon.reminder {
  background: #fff7f0;
  color: #f97316;
}

.panel-action-btn {
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #64748b;
  padding: 5px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.panel-action-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}

.view-all-btn {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  background: #003e75;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s;
  position: relative; /* Ensure proper stacking */
  z-index: 1; /* Prevent button from being overlapped */
}

.view-all-btn:hover {
  background: #4d94d2;
}

.status-dot {
  position: absolute;
  bottom: 0;
    right: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid white;
}

.status-dot.online {
  background: #10b981;
}

.status-dot.offline {
  background: #94a3b8;
}

.status-dot.away {
  background: #f97316;
}

.status-dot.busy {
  background: #ef4444;
}

/* Animations */
@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(30px);
  opacity: 0;
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.3s ease;
}

.slide-right-enter-from {
  transform: translateX(-100%);
}

.slide-right-leave-to {
  transform: translateX(-100%);
}

.pulse {
  animation: none;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(0);
  }
}

.message-text {
  display: flex;
  align-items: flex-start;
  color: #64748b;
  margin-top: 4px;
  line-height: 1.4;
  overflow: hidden;
}

.message-text svg {
  flex-shrink: 0;
  margin-top: 3px;
  margin-right: 6px;
}

/* Message list container animation */
.list-enter-active,
.list-leave-active {
  transition: all 0.3s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.message-panel {
  position: absolute;
  top: 50px;
  right: -100px;
  width: 400px;
  max-width: 90vw;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  z-index: 1005;
  overflow: hidden;
  animation: fadeIn 0.2s ease;
  border: 1px solid #f0f0f0;
  max-height: 500px;
  display: none;
  flex-direction: column;
}

.message-panel.active {
  display: flex;
}

.message-header {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f1f5f9;
}

.message-title {
  display: flex;
  align-items: center;
  color: #4f46e5;
  font-size: 16px;
  font-weight: 600;
  
  svg {
    margin-right: 8px;
  }
}

.message-actions {
  .menu-btn {
    background: transparent;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
    cursor: pointer;
    transition: background-color 0.15s;
    
    &:hover {
      background-color: #f8fafc;
    }
  }
}

.message-list {
  overflow-y: auto;
  flex: 1;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f8fafc;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: #e2e8f0;
    border-radius: 4px;
  }
}

.message-item {
  padding: 16px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: flex-start;
  position: relative;
  cursor: pointer;
  
  &:hover {
    background-color: #f8fafc;
  }
  
  &.unread {
    background-color: rgba(79, 70, 229, 0.06);
    
    .message-sender-name {
      color: #111827;
      font-weight: 700;
    }
    
    .message-preview {
      color: #4b5563;
    }
    
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 3px;
      background-color: #4f46e5;
      border-radius: 0 2px 2px 0;
    }
  }
}

.message-sender-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  margin-right: 12px;
  flex-shrink: 0;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.status-indicator {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid white;
}

.status-indicator.online {
  background-color: #10b981;
}

.status-indicator.offline {
  background-color: #9ca3af;
}

.status-indicator.away {
  background-color: #f59e0b;
}

.message-content {
  flex: 1;
  min-width: 0;
  padding-right: 70px;
}

.message-sender-name {
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  margin-bottom: 4px;
}

.message-preview {
  font-size: 13px;
  color: #6b7280;
  display: flex;
  align-items: flex-start;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reply-icon {
  min-width: 14px;
  margin-right: 4px;
  margin-top: 2px;
}

.message-time {
  position: absolute;
  right: 16px;
  top: 16px;
  color: #9ca3af;
  font-size: 12px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.time-icon {
  margin-right: 4px;
}

.message-footer {
  padding: 12px 16px;
  border-top: 1px solid #f1f5f9;
}

.view-all-btn {
  width: 100%;
  background-color: #f1f5f9;
  color: #4f46e5;
  border: none;
  border-radius: 6px;
  padding: 10px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
  
  &:hover {
    background-color: #ebe9fe;
    color: #4338ca;
  }
  
  svg {
    margin-right: 6px;
  }
}

.notifications-dropdown {
  position: absolute;
  top: 50px;
  right: 10px;
  width: 400px;
  z-index: 1001;
}

.messages-dropdown {
  position: absolute;
  top: 50px;
  right: 10px;
  width: 400px;
  z-index: 1001;
}

.layout-topbar-right .layout-topbar-items li {
  position: relative;
}

.messages-panel-content {
  background-color: #f8f9fa;
  padding: 0;
}

.mobile-message-list {
  display: flex;
  flex-direction: column;
}

.mobile-message-item {
  display: flex;
  padding: 15px;
  background-color: #fff;
  margin-bottom: 1px;
  position: relative;
  transition: background-color 0.2s;
  align-items: center;
  border-left: 3px solid transparent;
}

.mobile-message-item.unread {
  border-left-color: #4d94d2;
}

.mobile-message-item:active {
  background-color: #f5f7fa;
}

.message-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 12px;
  position: relative;
  flex-shrink: 0;
}

.message-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.status-dot {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid white;
  z-index: 1;
}

.status-dot.online {
  background-color: #10b981;
}

.status-dot.offline {
  background-color: #94a3b8;
}

.status-dot.away {
  background-color: #f97316;
}

.message-preview {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.message-sender {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.message-sender strong {
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
}

.message-time {
  font-size: 13px;
  color: #94a3b8;
  white-space: nowrap;
  position: absolute;
  right: 15px;
  top: 15px;
}

.message-text-preview {
  color: #64748b;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  padding-right: 20px;
}

/* Mobil bildirim ve mesaj panelleri için düzeltmeler */
.mobile-fixed-panel {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 1002;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% - 56px);
  overflow: hidden;
}

.mobile-panel-header {
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-bottom: 1px solid #eee;
  background: #f9f9f9;
}

.mobile-panel-content {
  flex: 1;
  position: relative;
  z-index: 1;
  background-color: #f8f9fa;
}

.scrollable-content {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  height: 100%;
}

.mobile-panel-footer {
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  padding: 15px;
  border-top: 1px solid #eee;
  background: white;
}

.mobile-view-all-btn {
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #4361ee;
  background-color: #f0f4ff;
  font-weight: 600;
}

/* Mobil mesaj listesi düzenlemeleri */
.mobile-message-list {
  display: flex;
  flex-direction: column;
}

.mobile-message-item {
  display: flex;
  padding: 15px;
  background-color: #fff;
  margin-bottom: 1px;
  position: relative;
  transition: background-color 0.2s;
  align-items: center;
  border-left: 3px solid transparent;
}

.mobile-message-item.unread {
  border-left-color: #4d94d2;
}

/* View All Messages buton stilini güncelle */
.mobile-panel-footer .view-all-btn {
  background-color: #f0f4ff;
  color: #4361ee;
  border: none;
  border-radius: 8px;
  height: 44px;
  font-size: 14px;
  font-weight: 600;
}
</style>
